export default [
    {
        name:"WorkRegistration",
        path:"WorkRegistration",
        component:()=>import("@/view/WebViews/Copyright/WorkRegistration"),
        meta:{
            title:"作品登记",
        }
    },
    {
        name:"WorkSafeguard",
        path:"WorkSafeguard",
        component:()=>import("@/view/WebViews/Copyright/WorkSafeguard"),
        meta:{
            title:"作品维权",
        }
    },
]